import { Injectable, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import {
  INetworkDeviceCounts,
  IThreeGSunsetStatistics,
} from '../interfaces/iNetworkDevicesCounts';
import { DSRESTClient } from '../shared/communication-objects/restclient.service';
import { api } from '../shared/communication-objects/api-path';
import { LogService } from './log.service';

@Injectable()
export class DeviceService implements OnInit {
  private readonly apiURL = api`Device`;
  constructor(private restClient: DSRESTClient, private logger: LogService) {}

  ngOnInit(): void {}

  getAllNetworkDeviceCounts(): Observable<INetworkDeviceCounts> {
    let apiResponse = this.restClient.getDirect<INetworkDeviceCounts>(
      api`${this.apiURL}/GetAllNetworkDeviceCounts`,
    );
    return apiResponse.pipe(
      tap((response) => {
        this.logger.log('device/getAllNetworkDeviceCounts Response', response);
      }),
    );
  }

  getThreeGSunsetStatistics(): Observable<IThreeGSunsetStatistics> {
    let apiResponse = this.restClient.getDirect<IThreeGSunsetStatistics>(
      api`${this.apiURL}/getThreeGSunsetStatistics`,
    );
    return apiResponse.pipe(
      tap((response) => {
        this.logger.log('device/getSunsetStatistics Response', response);
      }),
    );
  }
}
